import React from 'react';
import { AccountProvider } from '../context/AccountContext';
import { BuilderLocaleProvider } from '../context/BuilderLocaleContext';
import { WidgetBuilderProvider } from '../context/WidgetBuilderContext';
import BuilderLayout from '../builder/BuilderLayout';

/**
 * Builder route: wraps state providers then renders the builder UI.
 * Landing is separate — builder-only, no billing UI.
 */
export default function BuilderPage() {
  return (
    <AccountProvider>
      <BuilderLocaleProvider>
        <WidgetBuilderProvider>
          <BuilderLayout />
        </WidgetBuilderProvider>
      </BuilderLocaleProvider>
    </AccountProvider>
  );
}
